import Modal, { ModalWidthEnum } from 'components/Modal';
import { Text, Title } from 'components/Typography';
import { useTabRelocation } from 'hooks/useTabRelocation';
import { useSignOutMutation } from 'redux/apiSlices/auth.slice';

const AdminLoginRedirectModal = ({ open }: { open: boolean }) => {
  const { refetch: redirectTab } = useTabRelocation();
  const [signOut] = useSignOutMutation();

  const handleGoToAdminApp = () => {
    redirectTab('/landlord');
    window.close();
  };

  const handleClose = async () => {
    await signOut();
  };

  return (
    <Modal
      centered
      size={ModalWidthEnum.Medium}
      visible={open}
      okText='Go to Admin App'
      onOk={handleGoToAdminApp}
      onCancel={handleClose}
    >
      <>
        <Title fontLevel={2} className='mb-7'>
          You are logged in as an Admin
        </Title>
        <Text>Admins have a different login portal. Please use the Admin App to access admin features.</Text>
      </>
    </Modal>
  );
};

export default AdminLoginRedirectModal;
